import { render } from "./AddPermissions.vue?vue&type=template&id=cb7a11f8&scoped=true&ts=true"
import script from "./AddPermissions.vue?vue&type=script&lang=ts"
export * from "./AddPermissions.vue?vue&type=script&lang=ts"

import "./AddPermissions.vue?vue&type=style&index=0&id=cb7a11f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7a11f8"]])

export default __exports__